import { MeetingTimelineItemDto } from '@interfaces/meetings/responses/meeting.response';

/**
 * Itens da linha do tempo que a tela mostra (card 3244): no modo resumido, só os relevantes (bot, organizador e
 * outros gravadores); com "Ver todas as entradas e saídas", todos. A ordem é a do backend. Pura, com spec isolado.
 */
export function itensVisiveisDaLinhaDoTempo(
  itens: MeetingTimelineItemDto[] | null | undefined,
  verTudo: boolean
): MeetingTimelineItemDto[] {
  const todos = itens ?? [];
  return verTudo ? todos : todos.filter(i => i.relevant);
}
